import { reject } from "lodash";
import Vue from "vue";

const state = {
	tenantstats: {},
	_stats_loading: 0,
};

const getters = {
	getTenantstats: (state) => state.tenantstats,
	stats_loading: (state) => state._stats_loading !== 0,
};

const actions = {
	getTenantStats({ commit, dispatch }, params) {
		commit("START_STATS_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.get("/api/tenant/stats", { params: params })
				.then((res) => {
					commit("FETCH_TENANTSTATS", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_STATS_LOADING");
				});
		});
	},
};

const mutations = {
	FETCH_TENANTSTATS(state, data) {
		Vue.set(state, "tenantstats", data);
	},
	START_STATS_LOADING(state) {
		state._stats_loading++;
	},
	STOP_STATS_LOADING(state) {
		state._stats_loading--;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
